export const SURVEY_API_SERVICE_KEY = Symbol()
export const DETAIL_SURVEY_SERVICE_KEY = Symbol()
export const ROOT_SURVEY_STORE_KEY = Symbol()
export const RESPONDENT_API_SERVICE = Symbol()
export const RESPONDENT_RATING_API_SERVICE = Symbol()
export const SURVEY_REPORT_DOWNLOAD_SERVICE_KEY = Symbol()
